
import useLocalStorageState from 'use-local-storage-state'

// this a hook that is used keep track of the current step in the sign up process
export type SignUpStep = "accountcreated" | "addvehicle" | "vehicleadded" | "locationinstructions" | "addlocation" | "locationadded" | "welcome";
export const useSignUpStep = () => {
  return useLocalStorageState<SignUpStep | null>("signupstep", { defaultValue: null });
};